import { FC } from "react";
import { observer } from "mobx-react-lite";
import appStore from "../../../stores/appStore";
import aboutPageStore from "../store/aboutPageStore";
import { Spinner } from "../../../components/ui/Spinner";
import { renderStringToHTML } from "../AboutPage";

const AboutCompany: FC = () => {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-2xl font-semibold">О компании</h2>
      {aboutPageStore.isLoading ? (
        <Spinner></Spinner>
      ) : (
        renderStringToHTML(String(aboutPageStore.getSection("about")))
      )}

      <h2 className="text-2xl font-semibold">Оплата и доставка</h2>
      {aboutPageStore.isLoading ? (
        <Spinner></Spinner>
      ) : (
        renderStringToHTML(String(aboutPageStore.getSection("delivery_payment")))
      )}
    </div>
  );
};

export default observer(AboutCompany);
